import React, { useEffect } from "react";
import FrontPlayingCard from "../../../../assets/images/OCH/front-playing-card.png";
import card from "../../../../assets/images/card";
import _ from "lodash";
import { compose } from "redux";
import { connect } from "react-redux";
import { withSocket } from "../../../../socket/context";

const CardsView = (props) => {
  const param = _.get(props, "paramsReducer.gameObj.screens.och");
  const roomData = _.get(props, "gameReducer.roomObj");
  const status = _.get(roomData, "game_state.status");
  const currentCard = _.get(roomData, "game_state.current_card");
  const num = _.get(currentCard, "number");
  let imgSrc=''
  if(currentCard !== undefined){
    imgSrc = card[`${currentCard?.suit}`][num];
  }

  return (
    <div className="playingCardsSingleWrap">
      {status && status === "Playing" ? (
        <img src={currentCard.url} className="single-card-image" />
      ) : (
        <img src={param.cardback_img} className="single-card-image" />
      )}
    </div>
  );
};

const mapStateToProps = (state) => ({
  gameReducer: state.gameReducer,
  loaderDetails: state.loaderDetails,
  paramsReducer: state.paramsReducer,
});
const mapDispatchToProps = (dispatch) => {
  return {
    // setIsLoading: (data) => dispatch(loaderAction.setIsLoading(data)),
  };
};
export default compose(
  withSocket,
  connect(mapStateToProps, mapDispatchToProps)
)(CardsView);
// export default CardsView